import _ from 'lodash'

import Vue from 'vue'

// *****************************************************************************

//This class is for pull requests

export class lazy_scroll_requester_base {
  constructor(available_items, block_size) {
    this.available_items = available_items
    this.block_size = block_size
    this.needed_keys = new Set()
    this.request_id_to_requested_keys = {}
    this.reset_start_stop()
  }

  reset_start_stop() {
    this.start = undefined
    this.stop = undefined
  }

  initialize(available_items, block_size) {
    this.available_items = available_items
    this.block_size = block_size
  }

  range_is_empty_or_unchanged(start, stop) {
    const ok = start === stop || (start === this.start && stop === this.stop)
    return ok
  }

  compute_needed_keys() {
    let block_start = Math.floor(this.start / this.block_size)
    let block_stop = Math.floor(
      (this.stop + this.block_size - 1) / this.block_size
    )

    const needed_keys = new Set(
      _.map(_.range(block_start, block_stop), function(x) {
        return x.toString()
      })
    )
    return needed_keys
  }

  async fetch_key(key) {
    const request_id = _.uniqueId()
    this.request_id_to_requested_keys[request_id] = new Set([key])

    let res
    let ok = false
    try {
      res = await this.request_blocks([key])
      ok = true
    } finally {
      if (this.request_id_to_requested_keys.hasOwnProperty(request_id)) {
        delete this.request_id_to_requested_keys[request_id]
      }
    }
    if (ok) {
      for (const [key, value] of Object.entries(res)) {
        if (this.needed_keys.has(key)) {
          Vue.set(this.available_items, key, value)
        }
      }
    }
  }

  fetch_keys(needed_keys) {
    for (const key of needed_keys) {
      this.fetch_key(key)
    }
  }

  update(start, stop) {
    const ok = this.range_is_empty_or_unchanged(start, stop)
    this.start = start
    this.stop = stop
    if (ok) {
      return
    }

    let needed_keys = this.compute_needed_keys()
    this.needed_keys = needed_keys

    let should_update = false
    for (const key of Object.keys(this.available_items)) {
      if (!needed_keys.has(key)) {
        delete this.available_items[key]
        should_update = true
      }
    }

    let available_keys = new Set(Object.keys(this.available_items))

    let requested_keys = new Set(
      _.reduce(
        Object.values(this.request_id_to_requested_keys),
        (res, cur) => {
          res.push(...cur)
          return res
        },
        []
      )
    )

    needed_keys = new Set([...needed_keys].filter(x => !available_keys.has(x)))
    needed_keys = new Set([...needed_keys].filter(x => !requested_keys.has(x)))

    if (needed_keys.length !== 0) {
      needed_keys = [...needed_keys]
      this.fetch_keys(needed_keys)
    }
  }

  refresh() {
    if (this.needed_keys.length !== 0) {
      const needed_keys = [...this.needed_keys]
      this.fetch_keys(needed_keys)
    }
  }

  reset() {
    for (const key in this.available_items) {
      if (this.available_items.hasOwnProperty(key)) {
        Vue.delete(this.available_items, key)
      }
    }
    // So that an old request will not be taken into account
    // when changing rawfile_uid
    this.request_id_to_requested_keys = {}
    const [start, stop] = [this.start, this.stop]
    this.reset_start_stop()
    this.update(start, stop)
  }
}

// *****************************************************************************

//This class is for push requests

export class lazy_scroll_subscriber_base {
  constructor(block_size) {
    this.block_size = block_size
    this.needed_keys = new Set()
    this.reset_start_stop()
  }

  reset_start_stop() {
    this.start = undefined
    this.stop = undefined
  }

  initialize(block_size) {
    this.block_size = block_size
  }

  range_is_empty_or_unchanged(start, stop) {
    const ok = start === stop || (start === this.start && stop === this.stop)
    return ok
  }

  compute_needed_keys() {
    let block_start = Math.floor(this.start / this.block_size)
    let block_stop = Math.floor(
      (this.stop + this.block_size - 1) / this.block_size
    )

    const needed_keys = new Set(
      _.map(_.range(block_start, block_stop), function(x) {
        return x.toString()
      })
    )
    return needed_keys
  }

  update(start, stop) {
    const ok = this.range_is_empty_or_unchanged(start, stop)
    this.start = start
    this.stop = stop
    if (ok) {
      return
    }

    let needed_keys = this.compute_needed_keys()
    this.needed_keys = needed_keys

    this.fetch_keys(needed_keys)
  }

  refresh() {}

  reset() {
    const [start, stop] = [this.start, this.stop]
    this.reset_start_stop()
    this.update(start, stop)
  }
}
